<template>
    <div class="excellent_rates_grap" :id="'excellent_rates_grap' + this.id_type"></div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['graphicsData', 'id_type'],
    data() {
        return {
            dom_id: this.id_type
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {
        graphicsData: {
            handler() {
                this.participation_graphics()
            },
            deep: true,
        }
    },
    // 方法集合
    methods: {
        participation_graphics() {
            // console.log('this.graphicsData', this.graphicsData);

            let that = this;
            this.$echarts.init(document.getElementById('excellent_rates_grap' + this.dom_id)).dispose();
            let myChart = this.$echarts.init(
                document.getElementById('excellent_rates_grap' + this.dom_id)
            );

            // 使用虚拟数据进行测试
            const mockYData = ['一年一班', '一年二班', '一年三班', '一年四班', '一年五班', '二年一班', '二年二班'];
            const mockSemester1 = [0, 0, 0, 0, 0, 0, 0];
            const mockSemester2 = [0, 0, 0, 0, 0, 0, 0];
            const mockSemester3 = [0, 0, 0, 0, 0, 0, 0];

            // 如果传入了实际数据，则使用实际数据，否则使用虚拟数据
            const yData = that.graphicsData?.yData || mockYData;
            const semester1 = that.graphicsData?.semester1 || mockSemester1;
            const semester2 = that.graphicsData?.semester2 || mockSemester2;
            const semester3 = that.graphicsData?.semester3 || mockSemester3;

            myChart.setOption({
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        let result = params[0].name + '<br/>';
                        params.forEach(param => {
                            result += param.marker + param.seriesName + ': ' + param.value + '%<br/>';
                        });
                        return result;
                    },
                    axisPointer: {
                        type: 'shadow'
                    },
                    textStyle: {
                        fontSize: this.graphicRatio(12),
                    },
                },
                legend: {
                    icon: 'rect',
                    show: true,
                    bottom: '0%',
                    itemWidth: this.graphicRatio(22),
                    itemHeight: this.graphicRatio(14),
                    textStyle: {
                        // color: "#dbdbdb"
                        color: "#000",
                        fontSize: this.graphicRatio(12),
                    },
                    itemGap: this.graphicRatio(30),
                },
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: 0,
                        endValue: 7,
                        // start: 0,
                        // end: 100,
                    },
                ],
                grid: {
                    top: '10%',
                    left: '5%',
                    right: '2%',
                    bottom: '12%',
                    containLabel: true
                },
                xAxis: {
                    type: "category",
                    data: yData,
                    axisLine: {
                        lineStyle: {
                            // color: "rgba(117, 168, 202, 0.4)"
                            color: "#000",
                        },
                        show: true
                    },
                    axisTick: {
                        show: true,
                        color: "#dbdbdb"
                    },

                    axisLabel: {
                        color: "#000",
                        // color: "#dbdbdb",
                        fontSize: this.graphicRatio(14),
                        interval: 0,
                        rotate: 45
                    }
                },
                yAxis: [
                    {
                        type: "value",
                        inverse: false,
                        // max: 50,
                        splitLine: {
                            show: false,
                        },
                        axisLine: {
                            show: true,
                            lineStyle: {
                                // color: "#dbdbdb"
                                color: "#000",
                            }
                        },
                        axisLabel: {
                            show: true,
                            formatter: "{value}",
                            textStyle: {
                                // color: '#dbdbdb'
                                color: "#000",
                                fontSize: this.graphicRatio(14),
                            }
                        },
                        nameTextStyle: {
                            color: 'red',
                            padding: [0, 0, 0, 15]
                        },
                        axisTick: {
                            show: true
                        }
                    },
                ],
                series: [
                    {
                        name: '优良率',
                        type: 'bar',
                        barWidth: this.graphicRatio(25),
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                formatter: '{c}%',
                                fontSize: this.graphicRatio(14),
                                color: "#000",
                            },
                        },
                        itemStyle: {
                            borderRadius: [this.graphicRatio(5), this.graphicRatio(5), 0, 0],
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(84, 112, 198, 1)',
                            }, {
                                offset: 1,
                                color: 'rgba(84, 112, 198, 1)',
                            }])
                        },
                        data: semester1,
                    },
                    {
                        name: '合格率',
                        type: 'bar',
                        barWidth: this.graphicRatio(25),
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                formatter: '{c}%',
                                fontSize: this.graphicRatio(14),
                                color: "#000",
                            },
                        },
                        itemStyle: {
                            borderRadius: [this.graphicRatio(5), this.graphicRatio(5), 0, 0],
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(145, 204, 117, 1)',
                            }, {
                                offset: 1,
                                color: 'rgba(145, 204, 117, 1)',
                            }])
                        },
                        data: semester3,
                    },
                    {
                        name: '待提升',
                        type: 'bar',
                        barWidth: this.graphicRatio(25),
                        label: {
                            normal: {
                                show: true,
                                position: 'top',
                                formatter: '{c}%',
                                fontSize: this.graphicRatio(14),
                                color: "#000",
                            },
                        },
                        itemStyle: {
                            borderRadius: [this.graphicRatio(5), this.graphicRatio(5), 0, 0],
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(250, 200, 88, 1)',
                            }, {
                                offset: 1,
                                color: 'rgba(250, 200, 88, 1)',
                            }])
                        },
                        data: semester2,
                    }
                ]
            });
            window.addEventListener("resize", () => {
                myChart.resize();
            });
        },
        // participation_graphics() {
        //     // console.log('this.graphicsData', this.graphicsData);

        //     let that = this;
        //     this.$echarts.init(document.getElementById('excellent_rates_grap' + this.dom_id)).dispose();
        //     let myChart = this.$echarts.init(
        //         document.getElementById('excellent_rates_grap' + this.dom_id)
        //     );
        //     myChart.setOption({
        //         tooltip: {
        //             trigger: 'axis',
        //             formatter: "{a} <br/>{b} <br/>百分比: {c}%",
        //             axisPointer: {
        //                 type: 'shadow'
        //             },
        //             textStyle: {
        //                 fontSize: this.graphicRatio(12),
        //             },
        //         },
        //         legend: {
        //             icon: 'rect',
        //             show: true,
        //             bottom: '0%',
        //             itemWidth: this.graphicRatio(22),
        //             itemHeight: this.graphicRatio(14),
        //             textStyle: {
        //                 // color: "#dbdbdb"
        //                 color: "#000",
        //                 fontSize: this.graphicRatio(12),
        //             },
        //             itemGap: this.graphicRatio(30),
        //         },
        //         dataZoom: [
        //             {
        //                 type: 'inside',
        //                 startValue: 0,
        //                 endValue: 7,
        //                 // start: 0,
        //                 // end: 100,
        //             },
        //         ],
        //         grid: {
        //             top: '10%',
        //             left: '5%',
        //             right: '2%',
        //             bottom: '12%',
        //             containLabel: true
        //         },
        //         xAxis: {
        //             type: "category",
        //             data: that.graphicsData.yData,
        //             axisLine: {
        //                 lineStyle: {
        //                     // color: "rgba(117, 168, 202, 0.4)"
        //                     color: "#000",
        //                 },
        //                 show: true
        //             },
        //             axisTick: {
        //                 show: true,
        //                 color: "#dbdbdb"
        //             },

        //             axisLabel: {
        //                 color: "#000",
        //                 // color: "#dbdbdb",
        //                 fontSize: this.graphicRatio(14),
        //                 interval: 0,
        //                 rotate: 45
        //             }
        //         },
        //         yAxis: [
        //             {
        //                 type: "value",
        //                 inverse: false,
        //                 // max: 50,
        //                 splitLine: {
        //                     show: false,
        //                 },
        //                 axisLine: {
        //                     show: true,
        //                     lineStyle: {
        //                         // color: "#dbdbdb"
        //                         color: "#000",
        //                     }
        //                 },
        //                 axisLabel: {
        //                     show: true,
        //                     formatter: "{value}",
        //                     textStyle: {
        //                         // color: '#dbdbdb'
        //                         color: "#000",
        //                         fontSize:this.graphicRatio(14),
        //                     }
        //                 },
        //                 nameTextStyle: {
        //                     color: 'red',
        //                     padding: [0, 0, 0, 15]
        //                 },
        //                 axisTick: {
        //                     show: true
        //                 }
        //             },
        //         ],
        //         series: [
        //             {
        //                 name: that.graphicsData.title,
        //                 type: 'bar',
        //                 barWidth: this.graphicRatio(39),
        //                 // barWidth: 29,
        //                 label: {
        //                     normal: {
        //                         show: true,
        //                         // offset:[0,-30],
        //                         position: 'top',
        //                         // position: ['20%','-60%'],
        //                         formatter: '{c}%',
        //                         fontSize: this.graphicRatio(14),
        //                         // color: '#666666',
        //                         color: "#000",
        //                     },
        //                 },
        //                 itemStyle: {
        //                     borderRadius: [this.graphicRatio(5),this.graphicRatio(5), 0, 0],
        //                     color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //                         offset: 0,
        //                         color: that.graphicsData.colordata[0],
        //                     }, {
        //                         offset: 1,
        //                         color: that.graphicsData.colordata[1],
        //                     }])
        //                 },
        //                 data: that.graphicsData.semester1,
        //             },
        //         ]
        //     });
        //     window.addEventListener("resize", () => {
        //         myChart.resize();
        //     });
        // },
        // participation_graphics() {
        //     // console.log('this.graphicsData', this.graphicsData);

        //     let that = this;
        //     this.$echarts.init(document.getElementById('excellent_rates_grap' + this.dom_id)).dispose();
        //     let myChart = this.$echarts.init(
        //         document.getElementById('excellent_rates_grap' + this.dom_id)
        //     );
        //     myChart.setOption({
        //         tooltip: {
        //             trigger: 'axis',
        //             formatter: "{a} <br/>{b} <br/>百分比: {c}%",
        //             axisPointer: {
        //                 type: 'shadow'
        //             },
        //             textStyle: {
        //                 fontSize: this.graphicRatio(12),
        //             },
        //         },
        //         legend: {
        //             icon: 'rect',
        //             show: true,
        //             bottom: '0%',
        //             itemWidth: this.graphicRatio(22),
        //             itemHeight: this.graphicRatio(14),
        //             textStyle: {
        //                 // color: "#dbdbdb"
        //                 color: "#000",
        //                 fontSize: this.graphicRatio(12),
        //             },
        //             itemGap: this.graphicRatio(30),
        //         },
        //         dataZoom: [
        //             {
        //                 type: 'inside',
        //                 startValue: 0,
        //                 endValue: 7,
        //                 // start: 0,
        //                 // end: 100,
        //             },
        //         ],
        //         grid: {
        //             top: '10%',
        //             left: '5%',
        //             right: '2%',
        //             bottom: '12%',
        //             containLabel: true
        //         },
        //         xAxis: {
        //             type: "category",
        //             data: that.graphicsData.yData,
        //             axisLine: {
        //                 lineStyle: {
        //                     // color: "rgba(117, 168, 202, 0.4)"
        //                     color: "#000",
        //                 },
        //                 show: true
        //             },
        //             axisTick: {
        //                 show: true,
        //                 color: "#dbdbdb"
        //             },

        //             axisLabel: {
        //                 color: "#000",
        //                 // color: "#dbdbdb",
        //                 fontSize: this.graphicRatio(14),
        //                 interval: 0,
        //                 rotate: 45
        //             }
        //         },
        //         yAxis: [
        //             {
        //                 type: "value",
        //                 inverse: false,
        //                 // max: 50,
        //                 splitLine: {
        //                     show: false,
        //                 },
        //                 axisLine: {
        //                     show: true,
        //                     lineStyle: {
        //                         // color: "#dbdbdb"
        //                         color: "#000",
        //                     }
        //                 },
        //                 axisLabel: {
        //                     show: true,
        //                     formatter: "{value}",
        //                     textStyle: {
        //                         // color: '#dbdbdb'
        //                         color: "#000",
        //                         fontSize:this.graphicRatio(14),
        //                     }
        //                 },
        //                 nameTextStyle: {
        //                     color: 'red',
        //                     padding: [0, 0, 0, 15]
        //                 },
        //                 axisTick: {
        //                     show: true
        //                 }
        //             },
        //         ],
        //         series: [
        //             {
        //                 name: that.graphicsData.title,
        //                 type: 'bar',
        //                 barWidth: this.graphicRatio(39),
        //                 // barWidth: 29,
        //                 label: {
        //                     normal: {
        //                         show: true,
        //                         // offset:[0,-30],
        //                         position: 'top',
        //                         // position: ['20%','-60%'],
        //                         formatter: '{c}%',
        //                         fontSize: this.graphicRatio(14),
        //                         // color: '#666666',
        //                         color: "#000",
        //                     },
        //                 },
        //                 itemStyle: {
        //                     borderRadius: [this.graphicRatio(5),this.graphicRatio(5), 0, 0],
        //                     color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        //                         offset: 0,
        //                         color: that.graphicsData.colordata[0],
        //                     }, {
        //                         offset: 1,
        //                         color: that.graphicsData.colordata[1],
        //                     }])
        //                 },
        //                 data: that.graphicsData.semester1,
        //             },
        //         ]
        //     });
        //     window.addEventListener("resize", () => {
        //         myChart.resize();
        //     });
        // },
    },
    // 生命周期，创建完成时（可以访问当前this实例）
    created() {

    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        // console.log('this.graphicsData', this.graphicsData);

    },
}
</script>
<style scoped lang="less">
.excellent_rates_grap {
    width: 100%;
    height: 100%;
}
</style>